type Hook = (obj) => void;
declare var THREE: any;

const castShadowHook = (obj) => {
  obj.traverse(o => {
    o.castShadow = o.name === 'Steps' || o.name === 'Riser';
  });
};

const replaceMaterial = (obj) => {
  obj.traverse(o => {
    if (o.name === 'Steps') {
      o.material = new THREE.MeshStandardMaterial();
    }
  });
};

const hooks: Hook[] = [
  castShadowHook,
  replaceMaterial
];

export const applyHooks = (obj) => {
  hooks.forEach(h => h(obj));
};





// WEBPACK FOOTER //
// ./src/app/classes/modelLoadHooks.ts